import { Link } from "react-router-dom";
import ConfigurationSupplierModal from "./SupplierConfigurationModal";
import { useState } from "react";
import BankDetailsModal from "./BankDetailsModal";
import moment from "moment";
import { userRoleConstants } from "../../../utils/constants";
import localStorageStore from "../../../utils/localStorageStore";

const SupplierInfoCard = ({ supplier, masterData, flag, setFlag }) => {
  const [showConfiguration, setShowConfiguration] = useState(false);
  const [showBankDetails, setShowBankDetails] = useState(false);
  const isAccountant = parseInt(localStorageStore.getRole()) === userRoleConstants.ACCOUNTANT_ID;

  const activeBank = supplier?.BankAccounts?.find(bank => bank.status === true);
  
  return (
    <div className="row g-2">
      <div className="col-lg-7 col-sm-12 mb-2">
        <div className="card mb-2 h-100">
          <div className="card-body">
            <div className="d-flex justify-content-between">
              <div className="d-flex">
                <h4 className="ms-0 mb-0 text-primary">{supplier?.name || ""}</h4>
                <p className="badge p-2 bg-label-success ms-3">
                  {supplier?.status == 1 ? "Active" : "Inactive"}
                </p>
              </div>
              {!isAccountant && (
                <Link to="#" onClick={() => setShowConfiguration(true)}>
                  Edit
                </Link>
              )}
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="row">
                  <div className="col-md-4">
                    <p className="mb-1 mt-2">
                      ID: <span className="fw-medium">{supplier?.id}</span>
                    </p>
                  </div>
                  <div className="col-md-4">
                    <p className="mb-1 mt-2">
                      Country: <span className="fw-medium">{supplier?.Country?.name }</span>
                    </p>
                  </div>
                  <div className="col-md-4">
                    <p className="mb-1 mt-2">
                      Currency: <span className="fw-medium">{supplier?.currency}</span>
                    </p>
                  </div>
                  <div className="col-md-4">
                    <p className="mb-1 mt-2">
                      Commission: <span className="fw-medium">{supplier?.commission_avg}%</span>
                    </p>
                  </div>
                  <div className="col-md-4">
                    <p className="mb-1 mt-2">
                      Validity: <span className="fw-medium">{supplier?.validity || "NA"}</span>
                    </p>
                  </div>
                  <div className="col-md-4">
                    <p className="mb-1 mt-2">
                      Onboarding: <span className="fw-medium">{moment.utc(supplier?.createdAt ).format("DD MMM YY, hh:mm A")}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-5 col-sm-12 mb-2">
        <div className="card card-border-shadow-primary h-100">
          <div className="card-body py-2">
            <div className="d-flex justify-content-between mb-2">
              <h5 className="ms-0 mb-0">Bank Details</h5>
              <Link to="#" onClick={() => setShowBankDetails(true)}>Edit</Link>
            </div>
            <div className="row align-items-center">
              <div className="col-6 mb-2">
                <div className="d-flex align-items-center">
                  <div className="badge rounded-pill bg-label-info me-3 p-2">
                    <i className="ti ti-cash ti-sm"></i>
                  </div>
                  <div className="card-info">
                    <h6 className="mb-0">{activeBank?.bank_name || ""}</h6>
                    <small>Bank Name, {activeBank?.Country?.name || ""}</small>
                  </div>
                </div>
              </div>
              <div className="col-6 mb-2">
                <div className="d-flex align-items-center">
                  <div className="badge rounded-pill bg-label-warning me-3 p-2">
                    <i className="ti ti-calendar ti-sm"></i>
                  </div>
                  <div className="card-info">
                    <h6 className="mb-0">{activeBank?.ifsc_code }</h6>
                    <small>Code</small>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="d-flex align-items-center">
                  <div className="badge rounded-pill bg-label-primary me-3 p-2">
                    <i className="ti ti-wallet ti-sm"></i>
                  </div>
                  <div className="card-info">
                    <h6 className="mb-0">{activeBank?.account_number ? 'x'.repeat(activeBank.account_number.length - 4) + activeBank.account_number.slice(-4) : ''}</h6>
                    <small>Account No.</small>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="d-flex align-items-center">
                  <div className="badge rounded-pill bg-label-primary me-3 p-2">
                    <i className="ti ti-user ti-sm"></i>
                  </div>
                  <div className="card-info">
                    <h6 className="mb-0">{activeBank?.account_holder_name }</h6>
                    <small>Account Holder Name</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showConfiguration && <ConfigurationSupplierModal showConfiguration={showConfiguration} setShowConfiguration={setShowConfiguration} supplierData={supplier} masterData={masterData} flag={flag} setFlag={setFlag} />}
      {showBankDetails && <BankDetailsModal show={showBankDetails} onHide={() => setShowBankDetails(false)} supplierId={supplier?.id} supplier={supplier} masterData={masterData} flag={flag} setFlag={setFlag} />}
    </div>
  );
};
export default SupplierInfoCard;
